module.exports = __webpack_public_path__ + "img/egypt-logo-icon.0a0c40bb.png";